import { render, staticRenderFns } from "./cityAreaList.vue?vue&type=template&id=628f3f8a&scoped=true"
import script from "./cityAreaList.vue?vue&type=script&lang=js"
export * from "./cityAreaList.vue?vue&type=script&lang=js"
import style0 from "./cityAreaList.vue?vue&type=style&index=0&id=628f3f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f3f8a",
  null
  
)

export default component.exports